import { CatalogProduct } from '@interfaces/models/catalogProduct';
import { useCallback, useEffect, useMemo, useState } from 'react';
import useLocalStorage from '@hooks/use-local-storage';

const useHighlightDutiesTooltip = (products: CatalogProduct[]) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const [hasTooltipBeenShown, setHasTooltipBeenShown] = useLocalStorage('localsave/hasDutiesTooltipBeenShown', false);

  const onRowVisibleCallback = useCallback(
    (row: CatalogProduct[]) => {
      if (!showTooltip && !hasTooltipBeenShown && row.some((product) => product.hasNewTaxes)) {
        setShowTooltip(true);
        setHasTooltipBeenShown(true);
      }
    },
    [showTooltip, hasTooltipBeenShown, setHasTooltipBeenShown],
  );

  const shouldMountDutiesTooltip = useMemo(() => {
    return products.some((x) => x.hasNewTaxes);
  }, [products]);

  // hide the auto-show tooltip when the user scrolls
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    const hideTooltipListener = () => {
      setShowTooltip(false);
    };

    if (showTooltip) {
      // delay adding of scroll listener to avoid hiding tooltip straight away
      setTimeout(() => {
        window.addEventListener('scroll', hideTooltipListener);
      }, 1000);
    }
    return () => {
      window.clearTimeout(timeout);
      window.removeEventListener('scroll', hideTooltipListener);
    };
  }, [showTooltip]);

  return { showTooltip, setShowTooltip, onRowVisibleCallback, shouldMountDutiesTooltip };
};

export default useHighlightDutiesTooltip;
